export const iconFontAwesomeCommunicationVoicemail = (
	<i className="fa-solid fa-voicemail"></i>
);
